export enum InvoicePosType {

  ARTICLE = 'ARTICLE',
  TEXT = 'TEXT',
  EMPTY = 'EMPTY',
}
